import React from 'react';
import { Translate } from '../../../../components/translate/translate';
import { JobStatus } from '../../../../redux/jobs/jobs.types';
import { memoizedPartial } from '../../../../utils/function/memoized-partial';
import i18n from '../../../../utils/i18n/i18n';
import { AccordionItemContainer } from '../../accordion/accordion-item/accordion-item';
import { OperationRow } from '../../operations-table/operation-row/operation-row';
import { JobBasedOperation } from '../common/compress/job-based-group.types';
import { jobStatusToGenericOperationStatus } from '../common/utils/status.utils';
import styles from './download-group.scss';

function getTitle(operation: JobBasedOperation) {
  switch (operation.status) {
    case undefined:
    case JobStatus.PENDING:
      return i18n.t('operation-panel.multiple-download.title.preparing');

    case JobStatus.WORKING:
      return i18n.t('operation-panel.multiple-download.title.downloading', {
        count: operation.filesNumber,
      });

    case JobStatus.SUCCESS:
      return i18n.t('operation-panel.multiple-download.title.complete');

    case JobStatus.ERROR:
    default:
      return i18n.t('operation-panel.multiple-download.title.error');
  }
}

export interface OwnProps {
  groupId: string;
}

export interface StateProps {
  operation: JobBasedOperation;
}

export interface DispatchProps {
  closeGroup(groupId: string): void;
}

type Props = OwnProps & StateProps & DispatchProps;

export const DownloadGroup: React.FunctionComponent<Props> = ({
  groupId,
  operation,
  closeGroup,
}: Props) => {
  return (
    <AccordionItemContainer
      id={groupId}
      title={getTitle(operation)}
      onCloseClick={memoizedPartial(closeGroup, groupId)}
    >
      <OperationRow
        thumb={<div className={styles.zippingThumb} />}
        name={
          <Translate
            transKey="operation-panel.common.zipping-operation-name"
            params={{ count: operation.filesNumber }}
          />
        }
        size={operation.filesSize}
        status={jobStatusToGenericOperationStatus(operation.status)}
      />
    </AccordionItemContainer>
  );
};
